import React, { createContext, useContext, useState } from 'react';

const CustomerPresentationContext = createContext({ presenting: false, setPresenting: () => {} });

// In-session only. The presenting screen owns activation and unmount cleanup.
export function CustomerPresentationProvider({ children }) {
  const [presenting, setPresenting] = useState(false);
  return <CustomerPresentationContext.Provider value={{ presenting, setPresenting }}>{children}</CustomerPresentationContext.Provider>;
}

export const useCustomerPresentation = () => useContext(CustomerPresentationContext);
